import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
export function SelectPlaceholder(t0) {
  const $ = _c(3);
  const {
    title: t1
  } = t0;
  const title = t1 === undefined ? "Select" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      color: "var(--mui-palette-text-disabled)",
      alignContent: "center"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== title) {
    t3 = <Typography variant="body1" className="truncate" component="span" sx={t2}>{title}</Typography>;
    $[1] = title;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}